/**
 * Roles globales que gobiernan la consola del SSO. Los roles de las
 * aplicaciones integradas no viven en el codigo: son datos del ABM.
 */
export const SYSTEM_ROLES = {
  admin: 'SSO_ADMIN',
  auditor: 'SSO_AUDITOR',
} as const;

export const USER_TYPE_LABELS = {
  INTERNAL: 'Interno',
  EXTERNAL: 'Externo',
} as const;

export const USER_STATUS_LABELS = {
  INVITED: 'Invitado',
  ACTIVE: 'Activo',
  SUSPENDED: 'Suspendido',
} as const;

export const DEFAULT_PAGE_SIZE = 20;
